import { PhoneNumberUtil } from "google-libphonenumber"
import * as Yup from "yup"

const phoneUtil = PhoneNumberUtil.getInstance()

const validatePhoneNumber = (phoneNumber: string) => {
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, !phoneNumber.startsWith("+") ? "US" : undefined)

    return phoneUtil.isValidNumber(number)
  } catch (e) {
    return false
  }
}

export const phoneYupSchema = Yup.string()
  .test("is-valid-phone", "Phone number is not valid", (val) => (val ? validatePhoneNumber(val) : true))

export default validatePhoneNumber
